import React from 'react';
import { connect } from 'react-redux';
import '../../styles/play_styles.scss';
import config from '../../configuration.json';
import Navbar from './play_Navbar';
import Footer from './play_Footer';
import MyModal from '../../modal/newModal';
import axios from 'axios';
import Cookies from 'universal-cookie';
import { setDocusig } from '../../actions';
import { Navigate } from 'react-router-dom';
import { RenderInput } from '../../utils/renderInput';
import { validateCelebrateControls, removeInvalidValidClass } from './utils/handlerMessage';
import { useSearchParams } from "react-router-dom";
class Form extends React.Component {

    state = {
        scale: false,
        name: '', lastName: '', email: '', phone: '', useNavigation: null, code: ''

    };

    componentDidMount() {
        console.log('PlayThankYou component mounted with props:', this.props);
        window.addEventListener("resize", this.resize.bind(this));
        const params = new URLSearchParams(window.location.search);
        const code = params.get("code");
        if (code != null && code != undefined) {
            this.setState({ code });
            this.getCodeAndEmail(code);
        }
        this.resize();
    }

    enableSubmitButton() {
        // let bt = document.getElementById("participar_register_winner_data");
        //bt.removeAttribute("disabled");
    }
    getCodeAndEmail(code) {

        let formData = new FormData();
        let cookies = new Cookies();
        // this.showLoader();
        axios.get(`api/sign/code?code=${code}`, {
            withCredentials: true,
            headers: { Accept: "multipart/form-data", 'X-XSRF-TOKEN': cookies.get("XSRF-TOKEN") }
        }).then(response => {
            if (response.data.email == null || response.data.email == undefined) {
                this.handlerError();
            }
            if (response.data.phoneNumber != null && response.data.phoneNumber != undefined && response.data.phoneNumber != "") {
                // this.handlerErrorUser();
               this.setState({ envelopeId: response.data.envelopeId });
                setTimeout(() => {
                    this.sendForm();
                }, 120);
            }
            this.setState({ email: response.data.email });
            this.setState({ docusignId: response.data.docusignId });
            this.setState({ mailTemplateId: response.data.mailTemplateId });
        }).catch((e) => {
            this.handlerError()
        });
    }

    handleChangeInput(e, valueInput, maxLength, type, id) {
        let value = e.target.value.slice(0, maxLength);
        switch (type) {
            case "numeric":
                value = value.replace(/\D/g, '');
                break;
            default:
                value = value;
                break;
        }
        removeInvalidValidClass(id);
        this.state[valueInput] = value;
        this.state[id] = null;
        this.setState({ ...this.state });
        this.enableSubmitButton();
        return value
    }


    resize() {
        if (window.innerWidth <= 760) {
            this.setState({ scale: true });
        }
        else {
            this.setState({ scale: false });
        }
    }
    sendForm() {

        let formData = new FormData();
        let cookies = new Cookies();
        formData.append("name", this.state.name);
        formData.append("lastName", this.state.lastName);
        formData.append("phoneNumber", this.state.phone);
        formData.append("email", this.state.email);
        formData.append("signId", this.state.docusignId);
        formData.append("envelopeId", this.state.envelopeId);
        formData.append("mailTemplateId", config.PlayAndPizza.MailTemplateId);
        formData.append("code", this.state.code);
        formData.append("redirectUri", document.location.origin + `/${process.env.REACT_APP_HOME}`);

        // this.showLoader();
        axios.post('api/sign', formData, {
            withCredentials: true,
            headers: { Accept: "multipart/form-data", 'X-XSRF-TOKEN': cookies.get("XSRF-TOKEN") }
        }).then(response => {
            this.props.setDocusig(response.data);
            this.nextStep(response.data);
        }).catch((e) => {
            this.handlerError()
        });
    }

    nextStep(registerResult) {
        setTimeout(() => {
            this.setState({ useNavigation: <Navigate to={`/${process.env.REACT_APP_HOME}/recibido`} replace={true} /> });
        }, 100);
    }

    handlerError() {
        this.setState({ renderModal: <MyModal title="Error" content="Ha ocurrido algún error inesperado. Vuelve a intentarlo más tarde" /> });
        setTimeout(() => {
            this.setState({ useNavigation: <Navigate to={`/${process.env.REACT_APP_HOME}`} replace={true} /> });
        }, 2000);
    }

    handlerErrorUser() {
        this.setState({
            renderModal: <MyModal title="Error" content="<p><b>Este formulario ya ha sido enviado anteriormente.</b>
Para cualquier consulta, escríbenos a: <b>premios@mitelepi-juegaconpepsi.es</b></p>" />
        });
        setTimeout(() => {
            this.setState({ useNavigation: <Navigate to={`/${process.env.REACT_APP_HOME}`} replace={true} /> });
        }, 1500);
    }

    render() {
        const isFormValid =
            this.state.name.trim() !== "" &&
            this.state.lastName.trim() !== "" &&
            this.state.phone.trim() !== "" && this.state.phone.length === 9;
        return (
            <div>
                {this.state.useNavigation}
                <Navbar image={config.PlayAndPizza.HeaderIconlUrl} />

                <div className="cf-page">
                    <div className="cf-card">
                        <p className="cf-text">
                            Completa este formulario, y tu Carta de Aceptación. Solo necesitas completarla siguiendo las instrucciones. Una vez recibamos tus datos podremos entregarte tu entrada doble para vivir la Champions en vivo.
                        </p>

                        <form className="cf-form" onSubmit={(e) => e.preventDefault()}>
                            {RenderInput("Name", "name", "Nombre", 50, "", this)}
                            {RenderInput("LastName", "lastName", "Apellidos", 100, "", this)}
                            {RenderInput("Email", "email", "Email", 100, "email", this, true)}
                            {RenderInput("Nif", "phone", "Teléfono", 9, "numeric", this)}
                            {RenderInput("Code", "code", "Código", 20, "", this, true)}


                            {!isFormValid && (
                                <p className="cf-warning">
                                    ⚠️ Todos los campos son obligatorios para poder enviar el formulario.
                                </p>
                            )}
                            <button className="cf-btn" onClick={() => this.sendForm()} type="submit" disabled={!isFormValid}>
                                ENVIAR
                            </button>
                        </form>
                    </div>
                </div>
                {this.state.renderModal}
                <Footer footerName="thank-you-footer" message="Le recordamos que los datos que nos ha proporcionado durante la participación en la Promoción de la que ha resultado ganador se encuentran igualmente almacenados en un fichero responsabilidad de FOOD DELIVERY BRANDS para las finalidades y en los términos previstos en las Bases de la Promoción, siendo por tanto el presente texto complementario y no excluyente de lo establecido en dichas Bases. Si lo desea puede ejercitar sus derechos de acceso, rectificación, cancelación y oposición mediante comunicación escrita adjuntando una fotocopia/imagen del DNI dirigida a Calle Isla Graciosa, 7, San Sebastián de los Reyes (Madrid) o a la dirección de email dpo.es@fooddeliverybrands.com 
                " />
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        result: state.pageReducer.result,
    };
};

export default connect(mapStateToProps, { setDocusig })(Form);


